<template>
<div class="status-line" :style="controlStyle">
    <div style="position:relative;width:100%;height:4px;background-color:#bbb" :style="lineStyle"></div>

    <div style="display:flex;position: relative;top:-4px">
        <div v-for="(stage,index) in availableStages" class=" status-stage" :class="{completed: tagExists(stage)}" :style="statusStageStyle" :key="index">
            <div v-if="tagExists(stage)" class="stage-circle blue" :style="stageCircleStyle">
                <v-icon color="white">check</v-icon>
            </div>
            <div v-else class="stage-circle" :style="stageCircleStyle">
                <span style="padding-left:7px">{{index + 1}}</span>
            </div>
            <div class="stage-label">{{stage.name}}</div>
            <div class="stage-sublabel">{{tagDate(stage) |date}}</div>
            <div class="stage-namelabel">{{tagUser(stage)}}</div>
        </div>
    </div>

    
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'
import TagStatusHelpers from '../helpers/TagStatusHelpers'

export default {
    data() {
        return {

        }
    },

    components: {
        
    },
    
    props: {
        diameter: {
            type: Number,
            default: 32,
        },
        value: Object,
        availableStages: Array  //minimum {name: xxxx}
    },

    computed: {
        stageWidth() {
            return parseInt(100/this.availableStages.length)
        },
        statusStageStyle() {
            return {

                'flex-basis': this.stageWidth + '%'
            }
        },
        stageCircleStyle() {
            return {
                'height': this.diameter + 'px',
                'width': this.diameter + 'px',
            }
        },
        controlStyle() {
            return {
                'height': this.height + 'px'
            }
        },
        lineStyle() {
            return {
                'top': ((this.diameter / 2) - 2) + 'px'
            }
        },
        lineStageStyle() {
            return {
                'height': (this.height -2) + 'px',
                'width': (this.height -2) + 'px',
            }
        }
    },

    methods: {
        tagExists(stage) {
            // if(stage && this.value)
            //     debugger
            return TagStatusHelpers.tagExists(this.value, stage.name)
        },
        tagDate(stage) {
            return TagStatusHelpers.tagDate(this.value, stage.name)
        },

        tagUser(stage) {
            return TagStatusHelpers.tagUser(this.value, stage.name)
        }
    },

    created() {

    }
}
</script>

<style scoped>
    .status-stage {

    }
    .stage-circle {
        border-radius: 50%;
        border: solid 4px #cacaca;
        background-color:#fff; 
        margin: 0 auto;
        position: relative;
        color: #bbb;
        font-weight: 700;
    }

    .status-line {
        width: 100%;
        position: relative;
        border-radius:3px;
    }
    /* .status-line-stage {
        border-radius: 50%;
        border: solid 4px #bbb;
        background-color:white;
        position: relative;
    } */
    .stage-label {
        text-align: center;
        text-transform: uppercase;
        font-size: 12px;
        color:#999;
    }
    .stage-sublabel {
        margin-top:-3px;
        text-align: center;
        text-transform: uppercase;
        font-size: 12px;
        color:#999;
    }
    .stage-namelabel {
        margin-top:-3px;
        text-align: center;
        font-size: 10px;
        color:#aaa;
    }
    .completed .stage-label {
        color: #555;
    }
   
</style>




// WEBPACK FOOTER //
// StatusLine.vue?611c6480